import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    if (token && role) {
      if (role === "admin") {
        navigate("/admin/dashboard");
      } else {
        navigate("/user/dashboard");
      }
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(
        "/api/token",
        new URLSearchParams({ username, password }),
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      );

      const { access_token, role, place, department_name, image_url } = response.data;

      if (!access_token || !role) {
        throw new Error("Invalid response from server.");
      }

      // Extract device_ids from place array if needed
      const device_ids = place ? place.map(device => device.device_id) : [];
      
      localStorage.setItem("device_ids", JSON.stringify(device_ids));
      localStorage.setItem("place", JSON.stringify(place));
      localStorage.setItem("token", access_token);
      localStorage.setItem("role", role);
      localStorage.setItem("username", username);
     

      if (department_name) {
        localStorage.setItem("department_name", department_name);
      }

      if (image_url) {
        localStorage.setItem("image_url", image_url);
      }
      
      if (role === "admin") {
        navigate("/home");
      } else {
        navigate("/user/dashboard");
      }
    } catch (error) {
      setError("Invalid credentials. Please try again.");
    }
  };

  return (
    <div className="flex flex-col md:flex-row h-screen">
      {/* Left Side - Full Screen Image (hidden on mobile) */}
      <div className="hidden md:block md:w-1/2 h-full">
        <img
          src="/images/weathersensor.jpg"
          alt="Weather Sensor"
          className="w-full h-full object-cover blur-sm"
        />
      </div>

      {/* Right Side - Login Form (full width on mobile) */}
      <div className="w-full md:w-1/2 flex items-center justify-center bg-gray-100 min-h-screen md:min-h-0">
        <div className="w-full max-w-md p-4 md:p-8 bg-white rounded-lg shadow-md md:h-auto flex flex-col justify-center mx-4 my-4 md:mx-0 md:my-0">
          <img className="w-48 md:w-80 mb-8 md:mb-20 mx-auto" src="/images/logo.png" alt="Logo" />
          
          {error && <p className="text-red-500 text-center mb-4">{error}</p>}
          
          <form onSubmit={handleLogin} className="space-y-4">
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full p-2 border rounded"
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-2 border rounded"
              required
            />
            <div className="flex gap-10 justify-center ">
              <button
                type="submit"
                className="w-auto md:w-40 p-2 bg-black float-left text-white rounded hover:bg-gray-800 transition"
              >
                Login
              </button> 
            </div> 
          </form>
          <div className="flex gap-10 justify-center ">
            <a href="/ResetPassword">
              <button
                className="w-auto md:w-40 p-2 mt-2 bg-black float-left text-white rounded hover:bg-gray-800 transition"
              >
                Forgott Password
              </button> 
              </a>
            </div>
        </div>
      </div>
    </div>
  );
};

export default Login;